import * as React from 'react';
import NarrativeCodesDialogStore from 'store/narrativeCodes.dialog.store';
import { inject, observer } from 'mobx-react';
import { RootStore } from 'store/root.store';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    List,
    Tooltip
} from '@material-ui/core';
import * as Styled from './styled';
import { Language } from '@material-ui/icons';
import { withTranslation } from 'react-i18next';

interface Props {
    narrativeCodesDialogStore?: NarrativeCodesDialogStore;
    // tslint:disable-next-line:no-any
    t: any;
}

@inject((allStores: { rootStore: RootStore }) => {
    let rootStore = allStores.rootStore;
    return {
        narrativeCodesDialogStore: rootStore.narrativeCodesDialogStore
    };
})
@observer
class NarrativeCodesDialog extends React.Component<Props> {
    isFetching = false;
    cancel = () => {
        this.props.narrativeCodesDialogStore!.cancel();
    };

    fetchMoreitems = async ({ scrollHeight, scrollTop, clientHeight }:
                { scrollHeight: number, scrollTop: number, clientHeight: number }) => {
        let bottom = scrollHeight - scrollTop - clientHeight;
        if (bottom < 400 && !this.isFetching) {
            this.isFetching = true;
            await this.props.narrativeCodesDialogStore!.fetchMoreAvailNarratives();
            this.isFetching = false;
        }
    }

    render() {
        const { t, narrativeCodesDialogStore: store } = this.props;
        const { isOpen, narratives } = store!;

        return (
            <Dialog
                open={isOpen}
                onClose={this.cancel}
                maxWidth="md"
            >
                <DialogTitle>
                    <div>{t('narrative_field.dialog.narratives.title')}</div>
                </DialogTitle>
                <DialogContent onScroll={e => this.fetchMoreitems(e.currentTarget)}>
                    <Styled.NarrativeCodeHeader style={{backgroundColor: 'rgba(0,0,0,0)'}}>
                        <div />
                        <div>{t('narrative_field.dialog.narratives.table.header.code')}</div>
                        <div>{t('narrative_field.dialog.narratives.table.header.text')}</div>
                    </Styled.NarrativeCodeHeader>
                    <List>
                        {narratives.map((narrative, index) =>
                            <Styled.NarrativeCodeRows key={narrative.key}>
                                <div>{narrative.global && (
                                    <Tooltip title={t('narrative_field.dialog.narratives.table.row.icon.global')}><Language /></Tooltip>
                                )}</div>
                                <div>{narrative.key}</div>
                                <div>{narrative.replacement}</div>
                                <div>
                                    <Button
                                        onClick={(_e) => {
                                            this.props.narrativeCodesDialogStore!.selectNarrative(narrative);
                                        }}
                                    >
                                        {t('narrative_field.dialog.narratives.table.row.action.insert')}
                                    </Button>
                                </div>
                            </Styled.NarrativeCodeRows>
                        )}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.cancel}>{t('cancel', { ns: 'common' })}</Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withTranslation(['narratives', 'common'])(NarrativeCodesDialog);